// Invoice work categories + line item types (mirror of backend app/job_categories.py).
export const INVOICE_CATEGORIES = [
  { id: "engine", label: "Engine" },
  { id: "gearbox_clutch", label: "Gearbox & Clutch" },
  { id: "brakes", label: "Brakes" },
  { id: "suspension_steering", label: "Suspension & Steering" },
  { id: "exhaust", label: "Exhaust" },
  { id: "servicing", label: "Servicing" },
  { id: "mot", label: "MOT" },
  { id: "diagnostics", label: "Diagnostics" },
  { id: "electrical", label: "Electrical" },
  { id: "air_conditioning", label: "Air Conditioning" },
  { id: "tyres_wheels", label: "Tyres & Wheels" },
  { id: "bodywork", label: "Bodywork & Accident Repair" },
  { id: "recovery", label: "Recovery" },
  { id: "general_repairs", label: "General Repairs" },
  { id: "other", label: "Other" },
];

export const INVOICE_LINE_TYPES = [
  { id: "labour", label: "Labour / Service" },
  { id: "part", label: "Part / Stock Item" },
  { id: "external", label: "External Service / Subcontracted" },
  { id: "mot_fee", label: "MOT Fee / Retest Fee" },
  { id: "diagnostic", label: "Diagnostic Charge" },
  { id: "materials", label: "Materials & Consumables" },
  { id: "recovery", label: "Recovery / Delivery" },
  { id: "other", label: "Other Charge" },
  { id: "custom", label: "Custom Item" },
];

export const CATEGORY_LABEL = Object.fromEntries(INVOICE_CATEGORIES.map((c) => [c.id, c.label]));
export const LINE_TYPE_LABEL = { ...Object.fromEntries(INVOICE_LINE_TYPES.map((t) => [t.id, t.label])), service: "Service", note: "Note" };
